import { ActivatedRoute } from '@angular/router';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { Subject, firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { CustomComponent, IOrderDelivery, IPaymentIntent, PAYMENT_INTENT_STATUSES } from '@cakeiteasy/web-utils';

import { PaymentApiService } from '../../../api-services/services/payment-api.service';

@Component({
  standalone: false,
  selector: 'order-extra-payment',
  templateUrl: './order-extra-payment.component.html',
  styleUrls: ['./order-extra-payment.component.scss']
})
export class OrderExtraPaymentComponent extends CustomComponent implements OnInit, OnDestroy {
  public paymentIntent: IPaymentIntent;
  public deliveryOrder: IOrderDelivery;
  public infoMessage: { type?: string, text?: string } = null;
  public intent$ = new Subject<IPaymentIntent>();

  @Input() webhookUrlPrefix = '/';

  @Output() onShowMap = new EventEmitter<void>();

  constructor(private _paymentApi: PaymentApiService,
              private _route: ActivatedRoute,
              private _translation: TranslateService) {
    super();
  }

  ngOnInit() {
    this._initPaymentIntent().then((intent) => this.intent$.next(intent));
    this._pingIntent();
  }

  public paymentErrorProcess(responseError) {
    if (responseError && responseError.status === 422) {
      this.infoMessage = {
        type: 'success',
        text: this._translation.instant('paymentIntent.messages.paymentAlreadyConfirmed')
      };
    }
  }

  private _initPaymentIntent() {
    const { token } = this._route.snapshot.queryParams;

    return this._getPaymentIntent(token)
      .then((intent) => {
        this.paymentIntent = intent;
        this.deliveryOrder = this.paymentIntent.order.deliveryOrder;
        return intent;
      })
      .catch((errorResponse) => {
        if ([404, 422].indexOf(errorResponse.status) >= 0) {
          this.infoMessage = {
            type: 'error', text: this._translation.instant('paymentIntent.messages.orderNotFound')
          };
        }

        return null;
      });
  }

  private _pingIntent() {
    const { token } = this._route.snapshot.queryParams;

    this.addSubscriber(this.intent$.subscribe((intent) => {
      if (intent && intent.status === PAYMENT_INTENT_STATUSES.PAID) {
        const text = this._translation.instant('paymentIntent.messages.paymentHasBeenConfirmed');
        this.infoMessage = { type: 'success', text };
      } else {
        setTimeout(() => {
          firstValueFrom(this._paymentApi.getPaymentIntent(token))
            .then((pi) => this.intent$.next(pi));
        }, 1000);
      }
    }));
  }

  private _getPaymentIntent(token) {
    return firstValueFrom(this._paymentApi.getPaymentIntent(token));
  }
}
